<template>
<div class="trail__container">
	<trail-nav :display="displaySideNav"></trail-nav>
	<div class="trail__container--content">
		<div v-if="$store.state.loggedIn && $store.state.user.role === 'admin'" class="trail__edit">
			<router-link :to="{name:'Edit', params:{collection:'trails', id:trailData.slug}}" class="btn btn--orange">
				Edit Trail
			</router-link>
		</div>
		
		<section id="trail-summary" v-if="trailData.name" color="grey" class="trail__header">
			<trail-summary-card :trailData="trailData"></trail-summary-card>
		</section>
		<!-- <trail-section color="grey-dark" content="small">
			<div class="trail__menu">
				<button v-for="nav in menu" :key="nav.name" class="trail__menu--item" >{{nav.name}}</button>
			</div>						
		</trail-section> -->
		<trail-section id="trail-data" v-if="trailData.name" color="grey-light" title="Summary" subtitle="">
			<trail-data-summary :trailData="trailData"></trail-data-summary>
		</trail-section>
		<trail-section id="trail-map" v-if="trailData.gpx" color="grey" title="Map" subtitle="Navigate along the trail safely">
			<trail-map :trailData="trailData"></trail-map>
		</trail-section>
		<trail-section id="trail-link" v-if="trailData.links" color="grey-light" title="Useful Links" subtitle="Links related to this trail">
			<trail-links :trailData="trailData"></trail-links>
		</trail-section>
		<!-- <trail-section v-if="false" color="grey-dark" title="Weather" subtitle="Forecast on trail">
			<trail-weather :trailData="surveyData"></trail-weather>
		</trail-section> -->
		<!-- <trail-section color="grey" title="Trail Log" subtitle="Hike safely by recording your position frequently">
			<trail-log :trailData="trailData"></trail-log>
		</trail-section> -->
		<trail-section id="trail-survey" color="grey" title="Survey" subtitle="">
			<trail-survey :surveyData="surveyData" :trailData="trailData"></trail-survey>
		</trail-section>
		<trail-section id="trail-pictures" v-if="trailData.pictures" color="grey-light" title="Pictures" subtitle="">
			<trail-pictures :trailData="trailData"></trail-pictures>
		</trail-section>
		<trail-section id="trail-comment" v-if="trailData.id" color="grey" title="Comments" subtitle="">
			<trail-testimony :idTrail="trailData._id"></trail-testimony>
		</trail-section>
		<trail-section id="trail-nearby" v-if="trailData.nearby" color="grey-light" title="Trails nearby">
			<trail-nearby :trailNearby="trailData.nearby"></trail-nearby>
		</trail-section>
	</div>
</div>

</template>

<script>
import { defineAsyncComponent, computed, onMounted, ref, watch, onBeforeUnmount } from 'vue';
import Loading from '@/components/utils/Loading';
import { useRoute } from 'vue-router'
import axios from 'axios';

import {navigation} from "../composables/trails/nav";
import TrailNav from "@/components/trails/TrailNav";
import TrailSection from "@/components/trails/TrailSection";


// import TrailLog from "@/components/trails/TrailLog";
// import TrailWeather from "@/components/trails/TrailWeather";


const TrailSummary = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailSummary" /* webpackChunkName: "trail-summary" */),
  loadingComponent: Loading,
  suspensible: false
}); 
const TrailSummaryCard = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailSummaryCard" /* webpackChunkName: "trail-summary-card" */),
  loadingComponent: Loading,
  suspensible: false
}); 

const TrailDataSummary = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailData" /* webpackChunkName: "trail-data" */),
  loadingComponent: Loading,
  suspensible: false
}); 
const TrailMap = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailMap" /* webpackChunkName: "trail-map" */),
  loadingComponent: Loading,
  suspensible: false
}); 

const TrailSurvey = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailSurvey" /* webpackChunkName: "trail-survey" */),
  loadingComponent: Loading,
  suspensible: false
}); 
const TrailLinks = defineAsyncComponent({
  loader: ()=> import("@/components/trails/TrailLinks" /* webpackChunkName: "trail-link" */),
  loadingComponent: Loading,
  suspensible: false
}); 

const TrailPictures = defineAsyncComponent({
	loader: ()=> import('@/components/trails/TrailPictures' /* webpackChunkName: "trail-pictures" */),
	loadingComponent: Loading,
  	suspensible: false
}) 
const TrailTestimony = defineAsyncComponent({
	loader: ()=> import('@/components/trails/TrailTestimony' /* webpackChunkName: "trail-testimony" */),
	loadingComponent: Loading,
  	suspensible: false
}) 

const TrailNearby = defineAsyncComponent({
	loader: ()=> import('@/components/trails/TrailNearby' /* webpackChunkName: "trail-nearby" */),
	loadingComponent: Loading,
  	suspensible: false
}) 

import { useStore } from 'vuex';



export default {
  components: {
	  TrailDataSummary,
	  TrailLinks,
	  TrailMap,
	  TrailNav,
	  TrailNearby,
	  TrailSection,
	  TrailSummary,
	  TrailSummaryCard,
	  TrailSurvey,
	  TrailPictures,
	  TrailTestimony
  },
    // props:['slug'],
    setup(props){
		const store = useStore();
		const route = useRoute();
		const slug = route.params.slug;
		const trailData = ref({});
		const surveyData = ref({});
		const menu = ref(navigation);
		const displaySideNav = ref(false);



		// WATCH SURVEY IF USER VOTES
		watch(store.state, (newVal, oldVal) => {
			if(newVal.updateData){
				if(newVal.updateData.target === 'trailSurveyDataVote'){
					let data = newVal.updateData
					surveyData.value.forEach(s => {
						if(s._id === data.surveyId){
							s.userVote = true,
							s.voteAvg = (( s.voteAvg * s.voteCount ) + data.voteRating ) / (s.voteCount + 1);
							s.voteCount ++;
						}
					});
					store.state.updateData = {};
				}
			}
		})

		watch(()=> route.params, () => {
			if(route.name === 'Trail'){
				getTrail(route.params.slug)
			}
		})

		onMounted(async ()=>{
			await getTrail(slug);

			// SCROLL SIDE MENU
			scrollMenu();
		})

		onBeforeUnmount(() => {
			window.removeEventListener('scroll', toggleSideNav);
		})


	const scrollMenu = () => {
		window.addEventListener('scroll', toggleSideNav);
	}

	const toggleSideNav = () => {
		const  a = document.documentElement.scrollTop;
		const  b = document.getElementById('trail-summary').offsetHeight/2;
		const f = window.screen.height;
		const fPos = document.getElementById('footer').getBoundingClientRect().top;

		
		if (b > a ||  fPos-f < 0) {
			displaySideNav.value = false
		} else {
			displaySideNav.value = true
		}
	}


      const getTrail = async (slug) => {
        try{
			const result = await axios({
				method: "GET",
				url: "trails/"+ slug
			});

			
			trailData.value = result.data.data.data;
			surveyData.value = result.data.data.survey;

			//Gallery
			store.state.gallery = trailData.value.pictures;
		  
		  	//title
		  	document.title = document.title.replace('trailName', trailData.value.name);
			//Meta description
			const metaElem = document.querySelector('head meta[name="description"]');
			const metaOg = document.querySelector('head meta[property="og:description"]');
			 metaElem.setAttribute('content', trailData.value.coverDescription);
			 metaOg.setAttribute('content', trailData.value.coverDescription);

			
			
        }catch(err){
          console.log(err.response);
        }
      };
      

      return {displaySideNav, menu, surveyData, trailData}
    }
}
</script>

<style lang="scss" scoped>

@import '@/style/main.scss';
@import '@/style/page/trail';

.trail{
	&__edit{
		position: absolute;
		top: 8rem;
		right: 2rem;
		z-index: 1000;
	}

	&__container{
		display: flex;

		&--content{
			flex: 1;

			@include respond(phone){
				// margin: 0 1rem;
			}
		}
	}
}

</style>